module.exports = __webpack_public_path__ + "static/media/BN.301bf6aa.svg";